import { AxiosError } from "axios";

import { IApiDataState } from "@redux/store.types";

export const $ApiErrorsModuleName = "errors";

export type TApiErrorsSlice = {
    error: AxiosError;
    message?: string;
};

export type TApiErrorsState = Partial<IRootApiErrorsState>;

type IRootApiErrorsState = {
    [key in keyof IApiDataState]: TApiErrorsSlice;
};
